const UserResource = function ($resource, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'users/auth',
        {
            // TODO: Add deviceGuid in PRO-370
        },
        {
            login: {
                cache: false,
                method: 'POST',
                params: {
                    resolve: '*',
                    encodePrintableLogos: 1,
                },
            },
            check: {
                cache: false,
                method: 'GET',
                params: {
                    resolve: '*',
                    encodePrintableLogos: 1,
                },
            },
        }
    );
};

module.exports = UserResource;
